import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ReactSession } from "react-client-session";

import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import sha1 from "sha1";
import "./Login.css";
import show from "../../assets/show.svg";
import hide from "../../assets/hide.svg";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [uniquePrint, setUniquePrint] = useState();
  const inputRef = useRef(null);
  const passwordRef = useRef(null);

  let navigate = useNavigate();

  useEffect(() => {
    inputRef.current.focus();

    if (Number(sessionStorage.getItem("isLoggedIn")) === 1) {
      const role = ReactSession.get("role");
      if (role === "1") {
        navigate("/admin");
      } else if (role === "2") {
        navigate("/supervisor");
      } else if (role === "3") {
        navigate("/operator");
      } else {
        navigate("/");
      }
    }
  }, []);

  localStorage.clear();

  useEffect(() => {
    const fpPromise = FingerprintJS.load();

    const useragent = navigator.userAgent;

    var mainObj = {};

    const hash = async (str) => {
      const print = await sha1(str);
      console.log(print);
      setUniquePrint(print);
    };

    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        // This is the visitor identifier:
        const visitorId = result.visitorId;
        mainObj["timeZone"] = result.components.timezone.value;
        mainObj["userAgent"] = useragent;
        mainObj["canvas"] = result.components.canvas.value;
        mainObj["screenRes"] = result.components.screenResolution.value;
        mainObj["plugins"] = result.components.plugins.value;
        mainObj["fontsJS"] = result.components.fonts.value;
        mainObj["deviceMemory"] = result.components.deviceMemory.value;
        hash(JSON.stringify(mainObj));
      });
  }, []);

  // const URL = NODE_ENV === "production"
  const inputTypingStyles = {
    background: username !== "" && "white",
    backgroundSize: username !== "" && "0",
    backgroundPosition: username !== "" && "0",
    textIndent: username !== "" && "0",
  };

  const passwordTypingStyles = {
    background: password !== "" && "white",
    backgroundSize: password !== "" && "0",
    backgroundPosition: password !== "" && "0",
    textIndent: password !== "" && "0",
  };

  const togglePasswordHandler = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const submitHandler = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/auth/login`, {
        username,
        password,
        uniquecode: uniquePrint,
      });

      setIsLoading(false);

      ReactSession.set("username", res.data.authenticatedUser.username);
      ReactSession.set("role", res.data.authenticatedUser.role);
      ReactSession.set("accessToken", res.data.access);
      ReactSession.set("refreshToken", res.data.refresh);
      ReactSession.set("mog", res.data.scan_config.mog);
      ReactSession.set("varii", res.data.scan_config.varii);
      sessionStorage.setItem("isLoggedIn", 1);

      if (res.data.authenticatedUser.role === "1") {
        navigate("/admin");
      } else if (res.data.authenticatedUser.role === "2") {
        navigate("/supervisor");
      } else if (res.data.authenticatedUser.role === "3") {
        navigate("/operator");
      } else {
        navigate("/");
      }
    } catch (err) {
      setInvalidCredentials(true);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h3 className="login-heading">login</h3>

      <form className="form-container" onSubmit={submitHandler}>
        <div className="login-input-section" style={inputTypingStyles}>
          <label htmlFor="username" className="username-label">
            Username
          </label>
          <div
            className={`user-input-section  ${
              invalidCredentials ? "invalid-username" : ""
            }`}
          >
            <input
              type="text"
              id="username"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              className="user-input"
              placeholder="Enter Username"
              required
              ref={inputRef}
            />
          </div>
        </div>
        <div className="login-input-section" style={passwordTypingStyles}>
          <label htmlFor="password" className="password-label">
            Password
          </label>
          <div
            className={`
          user-input-section user-password-section ${
            invalidCredentials ? "invalid-password" : ""
          }`}
          >
            <input
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className=" user-input user-password"
              type={passwordType}
              placeholder="Enter Password"
              required
              ref={passwordRef}
            />
            <div className="password-icon">
              <img
                onClick={togglePasswordHandler}
                src={passwordType === "password" ? show : hide}
                alt="password-toggle"
              />
            </div>
          </div>
        </div>
        {invalidCredentials && (
          <small className="invalid-password_message">
            Please enter correct username or password
          </small>
        )}

        {/* <div className="forgot-password-wrapper">
          <Link className="password-forgot_password" to="forgot-password">
            Forgot Password ?
          </Link>
        </div> */}

        <button disabled={isLoading} className="login-btn">
          LOGIN
        </button>
      </form>
    </div>
  );
};

export default Login;
